import { convertStringToNumber, convertNumberToString, phpRound } from "./filters";
import {isEmpty} from "@/mixins/methods";
import { htmlToMd, mdToHtml } from "./methods";

const getLineDiscountValue = (line) => {
	// recreate API attribute to consider foreign_currency discount if exists
	if ((line?.discount_amount_foreign_currency ?? 0) !== 0)
		return line.discount_amount_foreign_currency;

	if ((line?.discount_amount ?? 0) !== 0)
		return line.discount_amount;

	if ((line?.discount_percent ?? 0) !== 0) {
		const lineAmount = (line?.amount_accurately_foreign_currency ?? 0) !== 0 ? line.amount_accurately_foreign_currency : line.amount_accurately ?? 0;
		const subtotal = (lineAmount * line.quantity) / 1000;
		const progress = line?.progress ?? 0;
		const adjustedSubtotal = progress !== null ? (subtotal * progress) / 10000 : subtotal;

		return ((line.discount_percent / 10000) * adjustedSubtotal);
	}

	return 0;
}
	
const formatTableToApi = table => {
	const _table = [];
	const { sections } = table;

	sections.forEach((section, index) => {
		_table[index] = {
			title: "",
			lines: []
		};

		const rows = [];

		Object.values(section).forEach(entry => {
			if (entry.component === "entry") {
				rows.push(entry);
			}
		});

		section.forEach(entry => {
			// Check if there is a title section
			if (entry.component === "section") {
				_table[index].title = entry.data?.title;
			} else if (entry.component === "comment") {
				const { comment } = entry.data;

				_table[index].lines.push({
					type: "description",
					detail: htmlToMd(comment || "")
				});
			} else if (entry.component === "entry") {
				const {
					designation,
                    reference,
					quantity,
					discount,
					totalQuantity,
					amount,
					amountWithTaxes,
					unity,
					vatPercentage,
					product,
					accountId,
					progress,
					amountWithTaxesDriven
				} = entry.data;

				if (rows.length > 1 && designation === "" && amount === "0,00") {
					return;
				}

				const apiEntry = {
                    reference: htmlToMd(reference ?? ""),
					detail: htmlToMd(designation || ""),
					stock_id: null,
					product_id: product?.id ?? null,
					account_id: accountId,
					type: "product",
					action: "sell",
					quantity: convertStringToNumber(quantity),
					amount_accurately: convertStringToNumber(amount) * 1000 * 100,
					amount_with_taxes: amountWithTaxesDriven ? convertStringToNumber(amountWithTaxes, 2) * 100 : null,
					vat_percent: convertStringToNumber(vatPercentage) * 100,
					discount: {
						amount: convertStringToNumber(discount.amount) * 100,
						percent: convertStringToNumber(discount.percent) * 100
					},
					unity,
					progress: convertStringToNumber(progress) * 100,
					total_quantity: convertStringToNumber(totalQuantity) * 100
				};

				_table[index].lines.push(apiEntry);
			}
		});
	});

	return _table;
};

/*
function strstr(haystack, needle, before_needle) {
	if (haystack.indexOf(needle) >= 0)
		return before_needle ? haystack.substr(0, haystack.indexOf(needle)) : haystack.substr(haystack.indexOf(needle));
	return false;
}
*/

const formatApiToTable = (content, foreign_currency_rate) => {
	const table = {
		sections: []
	};

	Object.values(content).forEach((section, index) => {
		const { title, lines } = section;

		// If section is still not defined
		if (typeof table.sections[index] === "undefined") {
			table.sections[index] = [];
		}

		if (title) {
			table.sections[index].push({
				component: "section",
				data: {
					title
				},
				key: `section${Math.floor(Math.random() * 100000 + 1)}`
			});
		}

		if (lines) {
			lines.forEach((line, index2) => {
				if (line?.type === "product") {
					/*
					const decimals = convertStringToNumber(
						line?.amount_accurately / 100 / 1000,
						line?.amount_accurately % 1000 > 0
							? strstr(convertNumberToString(line?.amount_accurately / 1000), ".", false).length - 1
							: 2
					);
					*/
					
					// if multidevise, define amounts
					let amount = (line.amount_accurately_foreign_currency ?? 0) !== 0 ? line.amount_accurately_foreign_currency : line.amount_accurately ?? 0;
					amount = amount / 1000 / 100; 
					
					let amountWithTaxes = (line.amount_with_taxes_foreign_currency ?? 0) !== 0 ? line.amount_with_taxes_foreign_currency : line.amount_with_taxes ?? 0;
					amountWithTaxes = amountWithTaxes / 100;


						
					table.sections[index].push({
						component: "entry",
						data: {
							reference: mdToHtml(line?.reference) ?? "",
							designation: line?.detail ? mdToHtml(line.detail.trim()) : "",
							// stock_id: null,
							product: {
								id: line?.product_id,
								type: line?.type
							},
							action: "sell",
							quantity: convertNumberToString(line?.quantity ?? 0.0),
							amount: convertNumberToString(amount),
							amountWithTaxes: convertNumberToString(amountWithTaxes),
							vatPercentage: line?.vat_percent / 100 ?? 0.0,
							discount: {
								value: convertNumberToString(getLineDiscountValue(line) / 100 ?? 0.0),
								amount: convertNumberToString(line?.discount?.amount / 100 ?? 0.0),
								percent: convertNumberToString(line?.discount?.percent / 100 ?? 0.0)					
							},
							unity:
								line?.unity && typeof line.unity === Number
									? convertNumberToString(line?.unity ?? 0.0)
									: line?.unity,
							totalQuantity: convertNumberToString(line?.total_quantity / 100 ?? 0.0),
							accountId: line?.account_id,
							progress: line?.progress / 100 ?? 0.0
						},
						key: `entry${Math.floor(Math.random() * 100000 + 1)}`
					});
				} else {
					const section_part = {
						component: "comment",
						data: {
							comment: mdToHtml(line?.detail?.trim() ?? "")
						},
						key: `comment${Math.floor(Math.random() * 100000 + 1)}`
					};
					table.sections[index].push(section_part);
				}

				if (lines.length - 1 === index2) {
					table.sections[index].push({
						component: "subtotal",
						data: {},
						key: `subtotal${Math.floor(Math.random() * 100000 + 1)}`
					});
				}
			});
		}
	});

	return table;
};

const formatHeadersToApi = enabledHeadersValues => {
	const columns = {
		line_number: enabledHeadersValues?.line_number ?? false,
        reference: enabledHeadersValues?.reference ?? false,
		designation: isEmpty(enabledHeadersValues?.designation) ? "" : enabledHeadersValues?.designation ,
		quantity: enabledHeadersValues?.quantity ?? false,
		quantity_name: enabledHeadersValues?.quantity_name ?? false,
		info_total_quantity: enabledHeadersValues?.info_total_quantity ?? false,
		progress: enabledHeadersValues?.progress ?? false,
		amount: enabledHeadersValues?.amount ?? false,
		amount_with_taxes: enabledHeadersValues?.amount_with_taxes ?? false,
		discount: enabledHeadersValues?.discount ?? false,
		subtotal: enabledHeadersValues?.subtotal ?? false,
		due: enabledHeadersValues?.due ?? false,
		vat_percent: enabledHeadersValues?.vat_percent ?? false
	};

	return columns;
};

export { formatTableToApi, formatApiToTable, formatHeadersToApi };
